// 足球 亚洲区世预赛 顶部菜单

module.exports = {
  sportType: 'football',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '概述',
        //   key: 'summary',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'zonePreScheduleIndex_FIFAWCQAZ',
          act: true,
        },
        {
          name: '球队',
          key: 'team',
          routeName: 'teamIndex_FIFAWCQAZ',
          act: false,
        },
        {
          name: '球员',
          key: 'player',
          routeName: 'playerIndex_FIFAWCQAZ',
          act: false,
        },
        {
          name: '积分榜',
          key: 'leagueTable',
          routeName: 'leagueTableIndex_FIFAWCQAZ',
          act: false,
        },
        {
          name: '数据',
          key: 'record',
          routeName: 'record',
          act: false,
          child: [
            {
              name: '数据概览',
              key: 'dataOverview',
              act: false,
              routeName: 'recordDataOverviewIndex_FIFAWCQAZ',
            },
            {
              name: '球队数据',
              key: 'teamData',
              act: false,
              routeName: 'recordTeamDataIndex_FIFAWCQAZ',
            },
            {
              name: '球员数据',
              key: 'playerData',
              act: false,
              routeName: 'recordPlayerDataIndex_FIFAWCQAZ',
            },
          ],
        },
        {
          name: '场馆',
          key: 'sportsHall',
          routeName: 'sportsHallIndex_FIFAWCQAZ',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'programListIndex_FIFAWCQAZ',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'broadcastListIndex_FIFAWCQAZ',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'dataPackagListIndex_FIFAWCQAZ',
          act: false,
          isOpenWeb: true,
        },
        // {
        //   name: 'H5组件',
        //   key: 'h5Comp',
        //   routeName: 'h5CompIndex_FIFAWCQAZ',
        //   act: false,
        // },
        // {
        //   name: 'API',
        //   key: 'openApi',
        //   routeName: 'openApiIndex_FIFAWCQAZ',
        //   act: false,
        // },
      ],
    },
  ],
}
